import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table,
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Spinner,
} from "reactstrap";
import CrearUsuario from "../modals/CreaUsuario";
import EditarUsuario from "../modals/EditarUsuario";

const ListaUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [cargando, setCargando] = useState(true);

  const obtenerUsuarios = async () => {
    try {
      setCargando(true);

      const response = await axios.get(
        "https://educacionapi.azurewebsites.net/api/ObtenerUsuarios",
      );

      if (Array.isArray(response.data)) {
        setUsuarios(response.data);
      }
    } catch (error) {
      console.error("Error al obtener usuarios:", error);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    obtenerUsuarios();
  }, []);

  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <Card>
            <CardHeader>Lista de Usuarios</CardHeader>

            <CrearUsuario onUsuarioCreado={obtenerUsuarios} />

            <CardBody>
              {cargando ? (
                <Spinner color="primary" />
              ) : (
                <Table bordered responsive>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nombre</th>
                      <th>Correo</th>
                      <th>Regional</th>
                      <th>Área</th>
                      <th>Tipo Usuario</th>
                      <th>Gestor Asignado</th>
                      <th>Editar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {usuarios.map((usuario) => (
                      <tr key={usuario.id}>
                        <td>{usuario.id}</td>
                        <td>{usuario.nombre}</td>
                        <td>{usuario.correo}</td>
                        <td>{usuario.regional}</td>
                        <td>{usuario.area}</td>
                        <td>{usuario.tipoUsuario}</td>
                        <td>{usuario.gestorAsignado}</td>
                        <td>
                          <EditarUsuario
                            usuario={usuario}
                            onActualizado={obtenerUsuarios}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ListaUsuarios;
